import {getInitCase} from "./helper/getInitCase";
import {PageType} from "../../../enums/PageType";
import {create} from './create';
import {read} from './read';
import {pay} from './pay';
import {duplicate} from './duplicate';
import {transfer} from './transfer';
import {copy} from './copy';
import {readTransaction} from "./helper/readTransaction";
import {fork, put, takeLatest} from "../../../shared/SagaService";
import AppActions from "../../App/actions";
import {storeOriginalQuantities} from "../../TransactionTransfer/sagas/storeOriginalQuantities";
import actions from "../actions";
import {readLists} from "./helper/readLists";
import {readOutstanding} from "./helper/readOutstanding";
// import { readPendingInvoices } from "./helper/readPendingInvoices";
import {message} from "antd";
import {readCurrencyRate} from "./helper/readCurrencyRate";
import {getLists} from "./helper/getLists";
import {updateStore} from "./helper/updateStore";
import {updateForm} from "./helper/updateForm";
import {parseTransaction} from "./helper/parseTransaction";
import {listenForTransactionCalculations} from "../calculation/saga";
import {copyItems} from "./copyItems";
import { processRestoreAutosaveForm } from "./helper/processRestoreAutosaveForm";
import { L } from "../../List/reducer";

const mapPageTypeToActions = {
    [PageType.pay]: pay,
    [PageType.duplicate]: duplicate,
    [PageType.transfer]: transfer,
    [PageType.copy]: copy,
    [PageType.copy_items]: copyItems,
};

function* initTransaction(action, context) {
    const { transactionType, matchParams, form } = action;

    // ------------------------------------------------------------
    // STAGE 1: READING ALL NECESSARY DATA
    // ------------------------------------------------------------
    // Step 1: Read Lists
    const lists = getLists(transactionType);
    yield readLists(lists);

    // Step 2: Read Transaction (if applicable)
    const { transactionInitCase, originType, url, id } = getInitCase(transactionType, matchParams);

    let originTransaction = {};
    if (url) {
        originTransaction = yield readTransaction(url, null, context);

        // Step 2a: Store Original Quantities For TransactionTransfer
        yield storeOriginalQuantities(transactionType, originTransaction);

        // Step 2b: Read Outstanding (for Link Items)
        yield readOutstanding(transactionInitCase, transactionType, originTransaction);

        // Step 2c: Read contact persons
        if (originTransaction.contact_id) {
            yield readLists(
                [L.contact_persons], {
                    [L.contact_persons]: { contact_id: originTransaction.contact_id },
                },
            );
        }
    }

    // ------------------------------------------------------------
    // STAGE 2: PARSING THE DATA (and keeping track of no longer relevant data for autosave)
    // ------------------------------------------------------------
    // Step 1: New, Read, Pay, Duplicate, Transfer, Copy
    let transaction = {},
        isRestoreForm = false;

    switch (transactionInitCase) {
        case PageType.new: {
            const {
                transaction: transactionRes, // if isRestoreForm = true, this will be local storage data; else it's initData
                isRestoreForm: isRestoreFormRes, // true/false, whether user chooses to restore autosaved form
            } = yield create(transactionType);

            transaction = transactionRes;
            isRestoreForm = isRestoreFormRes;
            break;
        }

        case PageType.view:
            transaction = yield read(transactionType, originType, originTransaction);
            break;

        case PageType.pay:
        case PageType.duplicate:
        case PageType.transfer:
        case PageType.copy:
        case PageType.copy_items:
        {
            const { isProceed, transaction: transactionRes }
            = yield mapPageTypeToActions[transactionInitCase](transactionType, originType, originTransaction);

            if (!isProceed) // user chooses to go back
                return;

            transaction = transactionRes;
            break;
        }
        default:
            break;
    }

    // Step 2: Parse transaction; if is restore autosave form for New, process the form data.
    if (isRestoreForm) {
        yield put({
            type: actions.TRANSACTION_RESTORE_AUTOSAVE_DATA_REQUEST,
        });
        transaction = yield processRestoreAutosaveForm({
            transaction,
            transactionType,
            transactionInitCase,
        });
    }
    else {
        transaction = yield parseTransaction(transaction, transactionType) || {};
    }

    // ------------------------------------------------------------
    // STAGE 3: Update Store
    // ------------------------------------------------------------
    // Step 1: Read Currency Rate
    if (transactionInitCase !== PageType.view)
        yield readCurrencyRate(transaction.currency_code, transaction.date);

    // Step 2: Update Store
    yield updateStore(transaction, transactionType, transactionInitCase, isRestoreForm);
    yield updateForm(transaction, transactionType, form);

    // Step 3: Fetch Audit Logs
    if (transactionInitCase === PageType.view) {
        yield put({
            type: actions.TRANSACTION_READ_AUDITS_REQUEST,
            id,
            pageQueryString: null,
        });
    }
}

export function* initRequest() {
    yield takeLatest(actions.TRANSACTION_INIT_REQUEST, function* (action) {
        try {
            yield put({type: AppActions.APP_START_PULLING});
            yield initTransaction(action);
        }
        catch (error) {
            yield put({
                type: actions.TRANSACTION_INIT_ERROR,
                error,
            });
            yield message.error(error.message);
        }
        finally {
            yield put({type: AppActions.APP_STOP_PULLING});

            // Start calculations
            yield fork(listenForTransactionCalculations, {action});
        }
    });
}
